/**
 * THE CHIMNEY CAKE — Forms Frontend Handler
 * ------------------------------------------
 * Napojuje formuláře festival-jobs.html a franchise.html na Google Apps Script.
 *
 * POUŽITÍ:
 *  1. Vlož tento <script> tag na konec festival-jobs.html i franchise.html
 *     (nebo přidej do sdíleného custom.js, pokud ho oba page načítají)
 *  2. Doplň FORM_ENDPOINT URL (z Apps Script deploymentu — krok 6 v .gs souboru)
 *  3. V HTML formulářích over, že <form> má id="apply-form" (uprav pokud má jiné)
 *     a že submit button je type="submit"
 *  4. V Shopify/Liquid verzi: stejný princip, jen action atribut můžeš nechat "#"
 *     (JS to stejně přebije přes preventDefault)
 */

const FORM_ENDPOINT = 'https://script.google.com/macros/s/AKfycbzHuPAYKSUD96QXpeu4J1XQ6W20q7T7U-Odqakym_xPCmr6DoVRwEVhKj8f9vB2zCWU/exec';

document.addEventListener('DOMContentLoaded', () => {
  const form = document.querySelector('.apply-form');
  if (!form) return;

  // Typ formuláře se čte z data-form-type atributu na <form> tagu.
  // V Liquid přidej: <form class="apply-form" data-form-type="festival-jobs" ...>
  // nebo: <form class="apply-form" data-form-type="franchise" ...>
  const formType = form.dataset.formType;
  if (!formType) {
    console.error('Form is missing data-form-type attribute — submissions will not be tagged correctly.');
    return;
  }

  // Anti-spam time-trap: record when the form became available. Bots submit
  // near-instantly; the Apps Script rejects anything faster than a human could fill.
  const formLoadTime = Date.now();

  form.addEventListener('submit', async (e) => {
    e.preventDefault();

    // Anti-spam honeypot: humans never see/fill #company_website. If it has a
    // value, it's a bot — show a fake success and silently drop (don't send).
    const honeypot = form.querySelector('input[name="company_website"]');
    if (honeypot && honeypot.value.trim() !== '') {
      showSuccessMessage(form);
      return;
    }

    const submitBtn = form.querySelector('.btn-submit');
    const originalBtnText = submitBtn ? submitBtn.innerHTML : '';
    if (submitBtn) {
      submitBtn.disabled = true;
      submitBtn.innerHTML = 'Sending…';
    }

    // Posbírej data z formuláře
    const formData = new FormData(form);
    const data = { formType };

    formData.forEach((value, key) => {
      if (key.endsWith('[]')) {
        // libovolná checkbox skupina (faires[], event_types[], ...) — slož do pole
        const cleanKey = key.slice(0, -2);
        if (!data[cleanKey]) data[cleanKey] = [];
        data[cleanKey].push(value);
      } else {
        data[key] = value;
      }
    });

    // Anti-spam: how long the visitor spent on the form (Apps Script checks this).
    data.elapsed_ms = Date.now() - formLoadTime;

    try {
      await fetch(FORM_ENDPOINT, {
        method: 'POST',
        // 'no-cors' protože Apps Script Web Apps nevrací standardní CORS hlavičky;
        // odpověď nelze přečíst, ale request projde a uloží se v pořádku.
        mode: 'no-cors',
        headers: { 'Content-Type': 'text/plain' },
        body: JSON.stringify(data)
      });

      showSuccessMessage(form);
    } catch (err) {
      console.error('Form submit error:', err);
      if (submitBtn) {
        submitBtn.disabled = false;
        submitBtn.innerHTML = originalBtnText;
      }
      alert('Something went wrong sending your application. Please try again or email us directly.');
    }
  });
});

function showSuccessMessage(form) {
  form.innerHTML = `
    <div class="form-success" style="text-align:center; padding: 3rem 1rem;">
      <h3 style="font-family: 'Cinzel Decorative', serif; margin-bottom: 1rem;">Thank you!</h3>
      <p>Your application has been received. We reply to every submission within a week.</p>
    </div>
  `;
}
